import { createFromIconfontCN } from '@ant-design/icons';

export const IconFont = createFromIconfontCN({
    scriptUrl: process.env.REACT_APP_ICON_FONT_URL,
});
